<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OCheckboxGroup v-model="model" :disabled="normalizedDisabled" :code="code" @change="(attrs.onChange)">
      </OCheckboxGroup>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormCheckboxGroupProps } from './CheckboxGroup'
import OCheckboxGroup from '../../Input/CheckboxGroup/CheckboxGroup.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormCheckboxgroup', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, code } = defineProps<FormCheckboxGroupProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
